import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { ErrorState } from "@/components/ui";

import { SpaceEditor, type EditorAddress } from "../features/console/editor/SpaceEditor";
import { spaceByCode } from "../features/console/spaces/lib/address";
import { useConsole } from "../features/console/store";

/** The editor's whole view, addressable: the canvas, the panel, and the activity by its slug. */
type EditorSearch = EditorAddress;

function only(value: unknown): string | undefined {
  return typeof value === "string" && value !== "" ? value : undefined;
}

export const Route = createFileRoute("/console/spaces/$joinCode/control")({
  validateSearch: (search: Record<string, unknown>): EditorSearch => ({
    canvas: only(search.canvas),
    panel: only(search.panel),
    select: only(search.select),
  }),
  component: SpaceControlRoute,
});

function SpaceControlRoute() {
  const { joinCode } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();
  const space = useConsole((state) => spaceByCode(state.spaces, joinCode));

  if (space === undefined) return <ErrorState headline="No such space" />;
  return (
    <SpaceEditor
      space={space}
      address={search}
      onAddress={(next) => {
        void navigate({
          to: "/console/spaces/$joinCode/control",
          params: { joinCode },
          search: { canvas: next.canvas, panel: next.panel, select: next.select },
        });
      }}
    />
  );
}
